import { Box } from 'braid-design-system';
import * as styles from './LazyLoadedImg.css';

export const LazyLoadedImg = ({
  src,
  dataAutomation,
}: {
  src?: string;
  dataAutomation?: string;
}) =>
  src === undefined ? null : (
    <Box
      className={styles.brandLogo}
      data={{ automation: 'company-logo-container' }}
    >
      <Box display="flex" height="full">
        <img
          className={styles.fitParentContainer}
          src={src}
          loading="lazy"
          {...(dataAutomation && { 'data-automation': dataAutomation })}
        />
      </Box>
    </Box>
  );
